/**
 * Created by liufeng on 2017/12/12.
 */
export default {
  path: 'author',
  component: () => import('@/components/author'),
  children: [
    {
      path: '',
      name: 'Add',
      component: () => import('@/components/author/add'),
    },
    {
      path: 'success',
      name: 'Success',
      component: () => import('@/components/author/success'),
    },
    {
      path: 'sfail',
      name: 'Sfail',
      component: () => import('@/components/author/sfail'),
    },
    {
      path: 'cfail',
      name: 'Cfail',
      component: () => import('@/components/author/cfail'),
    },
    {
      path: 'change',
      name: 'Change',
      component: () => import('@/components/author/change'),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/author.js